import React from 'react'
import { useApp } from '../../contexts';
import { Text8, TextTitleLink } from "./styles";
import { ArrowRightIcon2 } from '../Icons/ArrowRightIcon';


export const ViewFullReportItem = ({ icon, title, content }) => {
    const { T } = useApp()
    return (
      <div className="flex items-center justify-between cursor-pointer">
        <div className="flex items-center gap-2">
          {icon}
          <div className="flex flex-col">
            <TextTitleLink>{T(title)}</TextTitleLink>
            <Text8>{T(content)}</Text8>
          </div>
        </div>
        <ArrowRightIcon2 />
      </div>
    );
}
